import Buttons from "../../../../components/ui/button/Buttons";
import { FormFieldTypes } from "../../../../data/formFieldType";

export const AddKeypositionData = {
  name: "CourseProviderApplicationFormData",

  initialState: {
    searchEmailAddress:"",
    corporateRoleId: "",
    firstName: "",
    salutationId: null,
    lastName: "",
    designation: "",
    email: "",
    jobLevelId: null,
    jobFunctionId: null,
    mobileNumberCountryId: null,
    mobileNumber: "",
    contactNumberCountryId: null,
    contactNumber: ""
  },

  formFields: [
    {
      id: "searchEmailAddress",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "searchEmailAddress",
      fieldSetting: {
        placeholder: "",
        // isMultiSelect: false,
      },
      validation: [{ type: "email" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "searchEmailButton",
      fieldType: FormFieldTypes.COMPONENT,
      additionalComponent: <Buttons
        buttonText="Search"
        buttonTypeClassName="success-btn d-block"
      />,
      style: {
        containerCss: "col-md-3 mb-3  mt-30-67",
      },
    },
    {
      id: "corporateRoleId",
      lable: "Key Representative",
      Field_Name: "Key Representative",
      fieldType: FormFieldTypes.SELECT,
      dataField: "corporateRoleId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "",
      lable: "",
      Field_Name: "",
      fieldType: FormFieldTypes.MAINFORMTITLE,
      dataField: "",
      fieldSetting: {
        formTitle: "",
      },
      style: {
        containerCss: "col-lg-6 mb-3 text-left",
      },
    },
    {
      id: "salutationId",
      lable: "First Name or Given Name",
      Field_Name: "First Name or Given Name",
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["salutationId", "firstName"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "lastName",
      lable: "Last Name or Surname",
      Field_Name: "Last Name or Surname",
      fieldType: FormFieldTypes.INPUT,
      dataField: "lastName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "designation",
      lable: "Designation",
      Field_Name: "Designation",
      fieldType: FormFieldTypes.INPUT,
      dataField: "designation",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "email",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "email",
      fieldSetting: {
        placeholder: "",
        allowSpace: false,
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "jobLevelId",
      lable: "Job Level",
      Field_Name: "Job Level",
      fieldType: FormFieldTypes.SELECT,
      dataField: "jobLevelId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "jobFunctionId",
      lable: "Job Function",
      Field_Name: "Job Function",
      fieldType: FormFieldTypes.SELECT,
      dataField: "jobFunctionId",
      fieldSetting: {
        placeholder: "Select",
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3",
      },
    },
    {
      id: "mobileNumberCountryId",
      lable: "Mobile Number",
      Field_Name: ["Country Code and Mobile Number"],
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["mobileNumberCountryId", "mobileNumber"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
        isDisable: true,
      },
      validation: [{ type: "" }],
      style: {
        containerCss: "col-md-6 mb-3 no-star",
      },
    },
    {
      id: "contactNumberCountryId",
      lable: "Telephone DID/Contact Number",
      Field_Name: ["Country Code and Telephone DID/Contact Number"],
      fieldType: FormFieldTypes.INPUTGROUPSELECT,
      dataField: ["contactNumberCountryId", "contactNumber"],
      fieldSetting: {
        placeholder: "Select",
        allowSpace: true,
        options: [],
        isDisable: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-3  radius-right-zero",
      },
    },
  ],

  formSetting: {
    isViewOnly: false,
  },
};
